import { observable, action } from 'mobx'
import Api from '@api/hotel/niuniu'

class Store {
  @observable hall = []
  @action
  getHall = async () => {
    let params = {
      status: 1,
      is_published: 1,
      page: 1,
      per_page: 100
    }
    const {
      data: { list = [] },
      success
    } = await Api.sitelist(params)
    if (success) {
      this.hall = list || []
    }
  }

  @observable menu = []
  @action
  getMenu = async () => {
    let params = {
      status: 1,
      is_published: 1,
      page: 1,
      per_page: 100
    }
    const {
      data: { list = [] },
      success
    } = await Api.menulist(params)
    if (success) {
      this.menu = list || []
    }
  }
}
export default Store
